export default __webpack_public_path__ + "static/media/FilterSVG.8ac5568f.svg";